import { render, staticRenderFns } from "./WebTaskTab.vue?vue&type=template&id=136a99a6&scoped=true&"
import script from "./WebTaskTab.vue?vue&type=script&lang=ts&"
export * from "./WebTaskTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a99a6",
  null
  
)

export default component.exports